import type { App } from 'vue'
import tooltip from '@eci-saas/ui/directives/tooltip'

export default {
  install(app: App) {
    app.directive('tooltip', tooltip)
    // 这里可以注册更多指令
  },
}
